import { createApp } from 'vue';
import { router } from '@/router';
import { store } from '@/store';
import { ConfigProvider, Lazyload } from 'vant';
import App from './App.vue';
import checkRedirect from '@/utils/wxSDK/checkRedirect';
import 'normalize.css';
// 全量引入vant样式，按需引入插件存在问题：函数组件样式按需引入后，CSS变量无法重写
import 'vant/lib/index.css';
import '@/styles/index.less';
// 配合 postcss-px2vp 一起使用，以 375 进行转换
import '@/styles/vant-custom.less';
import '@/assets/fonts/iconfont.css';
// Vant 桌面端适配
import '@vant/touch-emulator';
import { useConfigStore } from '@/store/modules/config';
import { getQuery, projectStorage } from '@tencent/fd-utils';
import { initFdServer } from '@tencent/fd-services';
import { useUserStore } from '@/store/modules/user';
import { httpConfig } from '@/config/httpConfig';
// 按本地配置初始化api服务功能
initFdServer(httpConfig);
const app = createApp(App);
// app.use(TDesign);
app.use(store);
app.use(Lazyload);
app.use(ConfigProvider);

const configStore = useConfigStore();
const userStore = useUserStore();
// 创建项目专属localStorage，需要以合作方corpId区分
// 更换合作方，需要重新验证合法性并登录
const corpId = getQuery('corpId');
const token = getQuery('token');
if (corpId && corpId !== 'undefined') {
  projectStorage.init(`assistant_${corpId}`);
}
projectStorage.set('urlToken', token);
// 该标记用来判断当前页面是否在redirect微信验证，防止过程中渲染出错误页，出现闪跳现象
let wechatRedirect = false;
configStore
  // 验证token有效性
  .checkToken({
    token,
    // corpId, // corpId 不再作为参数传递，而是通过 header 传参
    // areaCode: getQuery('areaCode'),
  })
  .then(async () => {
    const isCheckToken = projectStorage.get('isCheckToken');
    if (!isCheckToken) {
      throw new Error('checkToken:no');
    }
    await configStore.fetchDict();
  })
  .then(async () => {
    // 如果出现关键接口错误，后续逻辑不再执行
    if (!configStore.dict?.dynamicConfig?.feSysConfig) {
      throw new Error('dick:no');
    }
    const { feSysConfig } = configStore.dict.dynamicConfig;
    const config = {
      appid: feSysConfig.wxAppId,
      scope: 'snsapi_userinfo',
    };
    await checkRedirect(config, userStore.login); // 重定向获取 code（用户身份）
  })
  .catch((err) => {
    console.log('--error--', err.message);
    if (err.message === 'wechat_redirect') {
      wechatRedirect = true;
    }
  })
  .finally(() => {
    if (!wechatRedirect) {
      // console.log('xxx-mount-start');
      app.use(router);
      app.mount('#app');
      // console.log('xxx-mount-end');
    }
  });
